import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { useOpenHoursConfiguration } from '../../hooks/useOpenHoursConfiguration';
import { useTranslation } from 'react-i18next';

const OpenHours = ({ blok, isNested = false }) => {
  const openHours = useOpenHoursConfiguration();

  const { t } = useTranslation('labels');
  // TailwindCSS utility classes --- --- --- --- --->

  const padding = isNested
    ? 'my-4 px-4 md:px-4 py-2 md:py-4 is-nested'
    : 'px-4 md:px-8 py-2 md:py-4';

  const widths = {
    'w-full': 'w-full col-span-12',
    'w-3/4': 'w-full col-span-12 md:col-span-9',
    'w-2/3': 'w-full col-span-12 md:col-span-8',
    'w-1/2': 'col-span-12 md:col-span-6',
    'w-1/3': 'col-span-12 md:col-span-4',
    'w-1/4': 'w-full sm:w-1/2 md:w-1/3 lg:w-1/4 col-span-6 sm:col-span-3',
    auto: 'w-fit sm:max-w-prose',
  };

  // >--- --- --- --- --- TailwindCSS utility classes

  return (
    <div
      className={`${padding} rounded ${widths[blok.width]} text-box`}
      {...storyblokEditable(blok)}
    >
      <h4>{blok.title}</h4>
      <table className="mt-2">
        <tr>
          <td>
            <span className="font-crystalCondensed"> {t('monday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_monday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('tuesday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_tuesday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('wednesday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_wednesday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('thursday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_thursday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('friday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_friday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('saturday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_saturday_string || t('closed')}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span className="font-crystalCondensed">{t('sunday')}:</span>
          </td>
          <td>
            <span>
              {openHours.field_open_hours_sunday_string || t('closed')}
            </span>
          </td>
        </tr>
      </table>
    </div>
  );
};

export default OpenHours;
